import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Box, Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

export const useStyles = makeStyles()(theme => ({
  fieldMissing: {
    color: theme.palette.error.main,
  },
}))
/**
 * This component is used for the installation statement overview.
 * "isFieldOptional" is used to toggle if a label/datafield is required. If false, then the label in the overview is red as long is the data is missing
 */
const LabeledFieldDisplay: React.VFC<{ label: string; isFieldOptional?: boolean; dataField: string | number | boolean | null | undefined }> = ({
  label,
  isFieldOptional = false,
  dataField,
}) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const fieldMissing = isFieldOptional ? false : dataField === null || dataField === undefined

  return (
    <Box display="flex" justifyContent="space-between">
      <Typography variant="subtitle2" className={`${fieldMissing ? classes.fieldMissing : ''}`}>
        {label}
      </Typography>
      <Typography variant="subtitle2"> {dataField === true ? t('common.yes') : dataField === false ? t('common.no') : dataField} </Typography>
    </Box>
  )
}

export default LabeledFieldDisplay
